import { useCreateState } from '../../../../hooks/useCreateState';

export type DataSource = {
  Path: string,
  ArrayItemType: string,
  RuntimeName: string,
  Metadata: {
    Type: string,
    ArrayItemType: string,
    Description: string
  }
}

export type Dependency = {
  Name: string,
  ItemType: string,
  ItemId: string,
  Description: string,
  WorkflowVersion: number,
  WorkflowName: string,

}

export type AppState = {
  isOpen: boolean,
  selectedDataSource?: DataSource,
  dependencies: Dependency[]
}

export const initialState: AppState = {
  isOpen: false,

  selectedDataSource: undefined,
  dependencies: []
};

export default function useAppState() {
  return useCreateState({
    initialState,
    reducers: {
      selectDataSource: (state, action) => ({ ...state, selectedDataSource: action.payload, isOpen: true }),
      close: (state, action) => ({ ...state, isOpen: false, selectedDataSource: undefined })
    }
  });
}
